import { BetslipConfig } from '@frontend/sports/common/client-config-data-access';

import { BetslipPick } from '../../../../../core/picks/betslip-pick';
import { BetslipV2Pick } from '../../../../../core/picks/betslip-v2-pick';
import { BaseComboPrevention } from './combo-prevention';
import { ComboPreventionResult } from './combo-prevention-result.enum';

export class V2VirtualComboPrevention extends BaseComboPrevention<BetslipV2Pick, BetslipPick> {
    constructor(private betslipConfig: BetslipConfig) {
        super(BetslipV2Pick, BetslipPick);
    }

    validate(thisPick: BetslipV2Pick, otherPick: BetslipPick, isSystemBet: boolean): ComboPreventionResult {
        if (!this.betslipConfig.allowMixedVirtualsCombo) {
            if (otherPick instanceof BetslipV2Pick) {
                if (!otherPick.isVirtual) {
                    return ComboPreventionResult.OnlyVirtual;
                }
            } else {
                return ComboPreventionResult.OnlyVirtual;
            }
        }

        return ComboPreventionResult.AllCombo;
    }

    override canValidate(thisPick: BetslipV2Pick, otherPick: BetslipPick, ignoreGroupInfo: boolean = false): boolean {
        return super.canValidate(thisPick, otherPick, ignoreGroupInfo) && thisPick.isVirtual;
    }
}
